/* eslint-disable no-console */

const { DateTime: LuxonDateTime } = require('luxon');

export class DateTime {
  static offsetMillis = 0;

  static centralTimeOffSetFromUTCMillis = 0;

  static getCurrentDateTime() {
    return new Date(Date.now() + DateTime.offsetMillis);
  }

  static getCurrentDateTimeWithCentralOffset() {
    const centralTimeOffSetFromUTCMillis = Boolean(
      DateTime.centralTimeOffSetFromUTCMillis
    )
      ? DateTime.centralTimeOffSetFromUTCMillis
      : 0;

    const offsetMillis = Boolean(DateTime.offsetMillis)
      ? DateTime.offsetMillis
      : 0;
    return new Date(Date.now() + centralTimeOffSetFromUTCMillis + offsetMillis);
  }

  static setTimeOffsetMillis(offsetMillis: number) {
    DateTime.offsetMillis = offsetMillis;
  }

  static setTimezoneOffset(enableTimeZoneOffset) {
    if (enableTimeZoneOffset) {
      const currentDateInCentralTime =
        LuxonDateTime.local().setZone('America/Chicago');
      DateTime.centralTimeOffSetFromUTCMillis =
        currentDateInCentralTime.offset * 60 * 1000;

      console.log(
        `Timezone offset is enabled: ${DateTime.centralTimeOffSetFromUTCMillis}`
      );
    }
  }

  static setTimeMachineTesting(
    enableTimemachineTesting,
    timeMachineTestOffsetMillis
  ) {
    if (enableTimemachineTesting && timeMachineTestOffsetMillis) {
      DateTime.setTimeOffsetMillis(Number(timeMachineTestOffsetMillis));
      console.log(
        `Timemachine enabled: Current Time is ${DateTime.getCurrentDateTime()} using timeStampInMillies ${timeMachineTestOffsetMillis}}`
      );
    }
  }
}
